export const CLIP_UPDATE_TYPE = {
  // Segment Track
  ADD_SEGMENT_TRACK: 'ADD_SEGMENT_TRACK',
  REMOVE_SEGMENT_TRACK: 'REMOVE_SEGMENT_TRACK',

  // !! Currently only used to update the segment trim
  UPDATE_SEGMENT_TRACK: 'UPDATE_SEGMENT_TRACK',
  UPDATE_VIDEO_SEGMENT_TRACK: 'UPDATE_VIDEO_SEGMENT_TRACK',
  REORDER_SEGMENTS: 'REORDER_SEGMENTS',
  UPSERT_SEGMENT_TRANSITION_OUT: 'UPSERT_SEGMENT_TRANSITION_OUT',
  REMOVE_SEGMENT_TRANSITION_OUT: 'REMOVE_SEGMENT_TRANSITION_OUT',

  // Composite Segment
  ADD_COMPOSITE_SEGMENT_DELETE: 'ADD_COMPOSITE_SEGMENT_DELETE',
  REMOVE_COMPOSITE_SEGMENT_DELETE: 'REMOVE_COMPOSITE_SEGMENT_DELETE',
  UPDATE_COMPOSITE_SEGMENT_DELETE: 'UPDATE_COMPOSITE_SEGMENT_DELETE',

  BULK_ADD_COMPOSITE_SEGMENT_DELETES: 'BULK_ADD_COMPOSITE_SEGMENT_DELETES',
  BULK_PUT_COMPOSITE_SEGMENT_DELETE: 'BULK_PUT_COMPOSITE_SEGMENT_DELETE',

  // AI Edits bulk splits
  BULK_UPDATE_COMPOSITE_SEGMENT_SCENES: 'BULK_UPDATE_COMPOSITE_SEGMENT_SCENES',
  BULK_UPDATE_COMPOSITE_SEGMENT_EFFECTS: 'BULK_UPDATE_COMPOSITE_SEGMENT_EFFECTS',
  BULK_UPDATE_COMPOSITE_SEGMENT_DELETES: 'BULK_UPDATE_COMPOSITE_SEGMENT_DELETES',

  ADD_COMPOSITE_SEGMENT_DELETE_WORDS: 'ADD_COMPOSITE_SEGMENT_DELETE_WORDS',

  UPDATE_COMPOSITE_SEGMENT_WORDS: 'UPDATE_COMPOSITE_SEGMENT_WORDS',
  ADD_COMPOSITE_SEGMENT_EFFECT: 'ADD_COMPOSITE_SEGMENT_EFFECT',

  SPLIT_SEGMENT: 'SPLIT_SEGMENT',
  CREATE_HOOK: 'CREATE_HOOK',

  // Restore Composite Segment
  RESTORE_COMPOSITE_SEGMENT_DELETE: 'RESTORE_COMPOSITE_SEGMENT_DELETE',

  // Composite Scene
  ADD_COMPOSITE_SCENE: 'ADD_COMPOSITE_SCENE',
  ADD_COMPOSITE_SCENE_RANGE: 'ADD_COMPOSITE_SCENE_RANGE',
  REMOVE_COMPOSITE_SCENE: 'REMOVE_COMPOSITE_SCENE',
  UPDATE_COMPOSITE_SCENE: 'UPDATE_COMPOSITE_SCENE',

  // Element Track
  ADD_ELEMENT_TRACK: 'ADD_ELEMENT_TRACK',
  REMOVE_ELEMENT_TRACK: 'REMOVE_ELEMENT_TRACK',
  UPDATE_ELEMENT_TRACK: 'UPDATE_ELEMENT_TRACK',
  REPLACE_ELEMENT_TRACKS: 'REPLACE_ELEMENT_TRACKS',

  // Update Scene Crop Position
  UPDATE_SCENE_CROP_POSITION: 'UPDATE_SCENE_CROP_POSITION',
  TOGGLE_VIDEO_VISIBILITY_FROM_SCENE: 'TOGGLE_VIDEO_VISIBILITY_FROM_SCENE',

  UPDATE_CLIP_FIT_MODE: 'UPDATE_CLIP_FIT_MODE',
  UPDATE_CLIP_BORDERS_VISIBILITY: 'UPDATE_CLIP_BORDERS_VISIBILITY',
  UPDATE_CLIP_SIZE: 'UPDATE_CLIP_SIZE',
  UPDATE_CLIP_SPEAKER_LABELS: 'UPDATE_CLIP_SPEAKER_LABELS',
  UPDATE_CLIP_SPEAKER_LABEL_STYLES: 'UPDATE_CLIP_SPEAKER_LABEL_STYLES',

  // Captions
  UPDATE_CAPTIONS_POSITION: 'UPDATE_CAPTIONS_POSITION',
  UPDATE_CAPTION_STYLES: 'UPDATE_CAPTION_STYLES',
  TOGGLE_CAPTIONS: 'TOGGLE_CAPTIONS',
  UPDATE_CAPTION_PRESET: 'UPDATE_CAPTION_PRESET',

  UPDATE_CLIP_LAYOUT: 'UPDATE_CLIP_LAYOUT',
  UPDATE_CLIP_FONT_LOCATION: 'UPDATE_CLIP_FONT_LOCATION',

  UPDATE_WORD_HIGHLIGHT: 'UPDATE_WORD_HIGHLIGHT',
  UPDATE_VISIBLE_FACE_IDS: 'UPDATE_VISIBLE_FACE_IDS',
  UPDATE_VISIBLE_SPEAKERS: 'UPDATE_VISIBLE_SPEAKERS',
  UPDATE_VISIBLE_VIDEO_IDS: 'UPDATE_VISIBLE_VIDEO_IDS',

  UPDATE_TRACK_VISIBILITY: 'UPDATE_TRACK_VISIBILITY',

  // ! TODO: @hardik-goldcast Please remove this after susnset of older players
  UPDATE_MAGIC_LAYOUT: 'UPDATE_MAGIC_LAYOUT',
  UPSERT_ELEMENT_TRANSITION: 'UPSERT_ELEMENT_TRANSITION',

  // Transcript Editing
  EDIT_WORD: 'EDIT_WORD',
  HIDE_WORD: 'HIDE_WORD',
  SHOW_WORD: 'SHOW_WORD',
  CORRECT_ALL: 'CORRECT_ALL'
} as const;
